import moment from 'moment'
import Datetime from '../../utils/Datetime'

const state = {
	data: {
		devices_groups: [],
		devices: [],
		groups: [],
		patients: [],
		social_security_numbers: [],
		diseases: [],
		insurances: [],
		contacts: [],
		relations_contacts: [],
		readings: [],
		logs: [],
		appointments: [],
		pills: [],
		alerts: [],
		warnings: []
	}
}

const getters = {
	WARNINGS : state => user => {
		return state.data.warnings.filter(item => {
			return item.user_id === user.id
		})
	},
	WARNINGS_UNREAD_BY_PATIENT : state => (user, patient) => {
		return state.data.warnings.filter(item => {
			return item.user_id === user.id && item.reading_time == '' &&
				(item.args && item.args.virtual_watch && item.args.virtual_watch == patient.id)
		})
		.sort((a, b) => {
			const dateA = moment(a.create_time).valueOf(),
				dateB = moment(b.create_time).valueOf()

			if (dateA > dateB) {
				return -1;
			  }
			  if (dateA < dateB) {
				return 1;
			  }
			  // a must be equal to b
			  return 0;
		})
	},
	WARNINGS_UNREAD : state => user => {
		return state.data.warnings.filter(item => {
			return item.user_id === user.id && item.reading_time == ''
		})
		.sort((a, b) => {
			const dateA = moment(a.create_time).valueOf(),
				dateB = moment(b.create_time).valueOf()

			if (dateA > dateB) {
				return -1;
			  }
			  if (dateA < dateB) {
				return 1;
			  }
			  // a must be equal to b
			  return 0;
		})
	},
	WARNINGS_READ : state => user => {
		return state.data.warnings.filter(item => {
			return item.user_id === user.id && item.reading_time != ''
		})
		.sort((a, b) => {
			const dateA = moment(a.create_time).valueOf(),
				dateB = moment(b.create_time).valueOf()

			if (dateA > dateB) {
				return -1;
			  }
			  if (dateA < dateB) {
				return 1;
			  }
			  // a must be equal to b
			  return 0;
		})
	},
	DEVICES_GROUPS : state => {
		return state.data.devices_groups
	},
	DEVICES : state => {
		return state.data.devices
	},
	DEVICES_BY_GROUP : state => group => {
		return state.data.devices.filter(item => {
			return item.group_id === group.id
		})
	},
	DEVICES_BY_PACIENT : state => pacient => {
		return state.data.devices.filter(item => {
			return item.virtual_watch_id === pacient.id
		})
	},
	PATIENTS : state => {
		return state.data.patients
	},
	PATIENT_BY_ID : state => patientId => {
		return state.data.patients.find(item => {
			return item.id === patientId
		})
	},
	PATIENTS_BY_GROUP : state => group => {
		return state.data.patients.filter(item => {
			return item.group_id === group.id
		})
	},
	PATIENTS_READINGS_BY_TYPE : state => (patient, type, key = '00000000') => {
		return state.data.readings.filter(item => {
			return 	item.virtual_watch_id === patient.id &&
					item.type_id === type &&
					item.key === key
		})
	},
	PATIENTS_READINGS_LAST_SYNC : state => (patient) => {
		const readings = state.data.readings.filter(item => {
			return 	item.virtual_watch_id === patient.id
		})
		.sort((a, b) => {
			const dateA = moment(a.create_time).valueOf(),
				dateB = moment(b.create_time).valueOf()

			if (dateA > dateB) {
				return -1;
			  }
			  if (dateA < dateB) {
				return 1;
			  }
			  // a must be equal to b
			  return 0;
		})
		if (readings.length === 0)
			return null
		return readings[0].reading_time
	},
	PATIENTS_PILLS : state => patient => {
		return state.data.pills.filter(item => {
			return item.virtual_watch_id === patient.id
		})
	},
	PATIENTS_PILLS_OF_DAY : state => (patient, datetime) => {
		return state.data.pills.filter(item => {
			return item.virtual_watch_id === patient.id &&
				moment() >= moment(item.date_start) &&
				moment() <= moment(item.date_end) &&
				Datetime.isWeekDayForPill(item)
		})
	},
	PATIENTS_APPOINTMENTS : state => patient => {
		return state.data.appointments.filter(item => {
			return item.virtual_watch_id === patient.id
		})
	},
	PATIENTS_LOGS : state => patient => {
		const devices = state.data.devices.filter(item => {
			return item.virtual_watch_id === patient.id
		})
		return state.data.logs.filter(item => {
			return devices.find(device => device.id === item.device_id) !== undefined
		})
		.sort((a, b) => {
			const dateA = moment(a.create_time).valueOf(),
				dateB = moment(b.create_time).valueOf()

			if (dateA > dateB) {
				return -1;
			  }
			  if (dateA < dateB) {
				return 1;
			  }
			  // a must be equal to b
			  return 0;
		})
	},
	ALERTS : state => {
		return state.data.alerts
	},
	PATIENTS_ALERTS : state => patient => {
		return state.data.alerts.filter(item => {
			return item.virtual_watch_id === patient.id && item.status === 0
		})
		.sort((a, b) => {
			const dateA = moment(a.date).valueOf(),
				dateB = moment(b.date).valueOf()

			if (dateA > dateB) {
				return -1;
			  }
			  if (dateA < dateB) {
				return 1;
			  }
			  // a must be equal to b
			  return 0;
		})
	},
	PATIENTS_DISEASES : state => patient => {
		return state.data.diseases.filter(item => {
			return item.virtual_watch_id === patient.id
		})
	},
	PATIENTS_CONTACTS : state => patient => {
		return state.data.contacts.filter(item => {
			return item.virtual_watch_id === patient.id
		}).sort((a, b) => {
			if (a.type > b.type) {
				return 1;
			  }
			  if (a.type < b.type) {
				return -1;
			  }
			  // a must be equal to b
			  return 0;
		})
	},
	PATIENT : state => id => {
		return state.data.patients.find(item => {
			return item.id === id
		})
	},
	// PATIENTS_GROUPS : state => user => {
	// 	return state.data.groups.filter(item => {
	// 		return item.user_id === user.id
	// 	})
	// },
	PATIENTS_GROUPS : state => {
		return state.data.groups
	}
}

const mutations = {
	GET_PATIENTS : (state, payload) => {
		state.data = payload
	},
	ALERT_POST : (state, alert) => {
		state.data.alerts = [
			...state.data.alerts.filter(element => element.id !== alert.id),
			alert
		]
	},
	CONTACT_PUT : (state, payload) => {
		state.data.contacts.push(payload)
	},
	CONTACT_POST : (state, contact) => {
		state.data.contacts = [
			...state.data.contacts.filter(element => element.id !== contact.id),
			contact
		]
	},
	WARNING_POST : (state, warning) => {
		state.data.warnings = [
			...state.data.warnings.filter(element => element.id !== warning.id),
			warning
		]
	},
	CONTACT_DELETE : (state, contact) => {
		state.data.contacts = [
			...state.data.contacts.filter(element => element.id !== contact.id)
		]
	}
}

const actions = {
	GET_PATIENTS : async (context, refThis) => {
		let { data } = await refThis.$api.watches.getListAll(refThis, refThis.user_uid)
		context.commit('GET_PATIENTS', data)
	},
	GET_PATIENTS_BY_USER : async (context, { refThis, user }) => {
		let { data } = await refThis.$api.watches.getListAll(refThis, user.uid)
		context.commit('GET_PATIENTS', data)
	},
	CONTACT_PUT : async (context, { refThis, contact }) => {
		let { data } = await refThis.$api.profile.contacts.add(refThis, refThis.user_uid, refThis.watch_id, contact)
		context.commit('CONTACT_PUT', { ...contact, ...data })
	},
	CONTACT_POST : async (context, { refThis, contact }) => {
		let { data } = await refThis.$api.profile.contacts.edit(refThis, refThis.user_uid, refThis.watch_id, contact)
		context.commit('CONTACT_POST', contact)
	},
	CONTACT_DELETE : async (context, { refThis, contact }) => {
		let { data } = await refThis.$api.profile.contacts.delete(refThis, refThis.user_uid, refThis.watch_id, contact.id)
		context.commit('CONTACT_DELETE', contact)
	},
	WARNING_POST : async (context, { refThis, item }) => {
		let { data } = await refThis.$api.warnings.update(refThis, refThis.user_uid, item)
		context.commit('WARNING_POST', item)
	},
	ALERT_POST_AUTO_REPORT_CLOSE : async (context, { refThis, user, patient, alert }) => {
		context.commit('ALERT_POST', {...alert, status: 2 }) // 2 - DONE
		let { data } = await refThis.$api.alerts.addReport(refThis, user.uid, patient.id, alert.type_reading_id, alert.id, {
			user_uid: user.uid,
			status: 2, // 2 - DONE
			report: 'Auto report close'
		})
	}
}

export default {
	state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/modules/patients.js